import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">The Ramifications of Malicious Intent</p>
        <p className="chapter__paragraph">
          As evidenced by the deepfake of the Ukrainian president, the implications of deepfakes are
          widespread, from consumer scams to political propaganda, false court evidence, fake news,
          and videos that could even incite violence. Ukrainians who saw it might have initially
          believed the deepfake to be authentic, leading to dangerous consequences in the invasion.
          And while the video was determined to be fake fairly quickly, there could have been dire
          repercussions had its creators been a little bit savvier.
        </p>
        <p className="chapter__paragraph">
          <a
            href="https://www.intel.com/content/www/us/en/research/blogs/trusted-media.html#:~:text=Intel%20Labs'%20trusted%20media%20research,source%20detection%2C%20and%20media%20authentication.https://www.intel.com/content/www/us/en/newsroom/news/intel-introduces-real-time-deepfake-detector.html#gs.k4qace"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            Trusted Media
          </a>{' '}
          is a research effort by Dr. Demir and her team to both detect deepfakes and provide
          technology advancements creating safe and authentic synthetic content. The Trusted Media
          initiative is intended for several customer use cases. One is news agencies, which need to
          determine whether a third-party source material is real or manipulated before
          broadcasting. Another group is “AI for social good” organizations, democratizing the
          detection technology for non-profits, independent journalists, and individual users. A
          third group is social media, obviously very important to stop the spread of
          misinformation. And a fourth group is legitimate content creators—entertainment companies
          and studios, for example, to enable authentic and creative uses of deep generative models.
        </p>
        <p className="chapter__paragraph">
          When used transparently for entertainment purposes, there are legitimate applications of
          deepfake technology. “We don't want to eliminate all synthetic data,” Dr. Demir says, “but
          we want to enable those innovative creators like studios, animators, and metaverse content
          creators.”
        </p>
        <p className="chapter__paragraph">
          Fictional characters are inserted in movies using similar technology. “We can enable
          authentic, artistic content that we know its motivation, its source, how it was done, why
          it was done, and if it was done with consent,” Dr. Demir says. Another responsible use of
          deepfakes is to protect the identity of vulnerable populations in sensitive contexts,
          using deepfakes. “Deepfakes enable preserving the microexpressions, gestures, and emotions
          of the subject [while] masking their identity with a non-existing person to protect them,”
          she adds.
        </p>
        <p className="chapter__paragraph">
          Dr. Demir also has a project called, “
          <a
            href="https://arxiv.org/abs/2211.01361"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            My Face My Choice
          </a>
          ,” which utilizes quantifiably dissimilar deepfakes on photos shared on social media. This
          is to prevent mainstream face recognition algorithms from identifying people without
          consent.
        </p>
      </section>
    </>
  );
}

export default Chapter3;
